import { render, staticRenderFns } from "./DeactivatedActionDropdown.vue?vue&type=template&id=1a8489df&scoped=true"
import script from "./DeactivatedActionDropdown.vue?vue&type=script&lang=js"
export * from "./DeactivatedActionDropdown.vue?vue&type=script&lang=js"
import style0 from "./DeactivatedActionDropdown.vue?vue&type=style&index=0&id=1a8489df&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a8489df",
  null
  
)

export default component.exports